import PubSub from 'underpub-js';
import gsap from 'gsap';

var Loader = function(options) {
  this.options = {
    $el: false,
  };

  this.data = {
    baseClass: 'comp-Loader',
    hasLoaded: false,
  };

  $.extend(true, this.options, options);
};

Loader.prototype.init = function() {
  const self = this;

  self.$logo = self.options.$el.find(`.${self.data.baseClass}__logo`);
  self.$logoSVG = self.$logo.find('svg');

  self.initLoader();
  self.initLogoAnimation();
  self.initLoaderOutAnimation();

  $(window).on('load', () => self.handleWindowLoad());

  setTimeout(() => !self.data.hasLoaded && $(window).trigger('load'), 2000);
};

Loader.prototype.initLoader = function() {
  const self = this;

  gsap.set(self.$logo, { opacity: 1 });
  gsap.set('html', { overflow: 'hidden' });
};

Loader.prototype.killLoader = function() {
  const self = this;

  self.options.$el.hide();
  self.killLogoAnimation();
};

Loader.prototype.initLogoAnimation = function() {
  const self = this;

  self.logoAnimationTimeline = gsap
    .timeline({
      repeatDelay: 0.25,
      repeat: -1,
      paused: true,
      defaults: {
        ease: 'expo.easeout',
      },
    })
    .fromTo(
      self.$logoSVG,
      {
        duration: 1,
        opacity: 0,
        xPercent: -100,
        skewX: -4,
        scale: 1.05,
      },
      {
        opacity: 1,
        xPercent: 0,
        skewX: 0,
        scale: 1,
      },
    )
    .to(
      self.$logoSVG,
      {
        duration: 0.25,
        opacity: 0,
        xPercent: 70,
        skewX: 4,
        scale: 0.95,
      },
      '>.75',
    );

  self.playLogoAnimation();
};

Loader.prototype.initLoaderOutAnimation = function() {
  const self = this;

  self.loaderOutAnimationTimeline = gsap
    .timeline({
      delay: 1.1,
      paused: true,
      defaults: {
        ease: 'expo.easeout',
      },
      onStart: () => PubSub.publish('loaded'),
      onComplete: () => self.killLoader(),
    })
    .set('html', { clearProps: 'overflow' })
    .to(self.$logo, {
      duration: 0.3,
      opacity: 0,
    })
    .to(
      self.options.$el,
      {
        duration: 1,
        opacity: 0,
      },
      '<.2',
    );
};

Loader.prototype.playLogoAnimation = function() {
  const self = this;

  self.logoAnimationTimeline.play();
};

Loader.prototype.killLogoAnimation = function() {
  const self = this;

  self.logoAnimationTimeline.kill();
};

Loader.prototype.playLoaderOutAnimation = function() {
  const self = this;

  self.loaderOutAnimationTimeline.play();
};

Loader.prototype.handleWindowLoad = function() {
  const self = this;

  self.data.hasLoaded = true;
  self.playLoaderOutAnimation();
};

export default Loader;
